// A user profile: Upcoming / Past tabs.
import { wireCardLayout } from "./team_page/card_layout"
import { wireTabs } from "./team_page/timeline"

wireTabs()
wireCardLayout()
